const fetchSliderParent = node => {
  try {
    const classes = node.classList
    if (classes?.contains('o-SliderHorizontal')) {
      return {
        widgetID: node.getAttribute('data-crosssell-id'),
        widgetName: node.getAttribute('data-crosssell-title'),
      }
    } else if (!node.parentNode) {
      return
    } else {
      return fetchSliderParent(node.parentNode)
    }
  } catch (e) {
    return
  }
}

export default () => {
  document.addEventListener('click', function (event) {
    const target = event.target
    if (target?.href?.includes('new-cart')) {
      event.preventDefault()
      const href = target.href
      const offer = new URL(href).searchParams.get('offer')
      const widget = fetchSliderParent(target)

      window.dataLayer.push({
        event: 'cart.changed',
        payload: {
          id: offer,
          quantity: 1,
          ...widget,
        },
      })

      window.location.assign(href)
    }
  })
}
